import * as angular from "angular";

export class AppointmentService {
    private v2Root: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.v2Root = "/v2/appointment";
    }

    all(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/all", { params: data });
    }

    user(params: any): Promise<object> {
        return this.$http.get(this.v2Root + "/user", { params: params });
    }

    info(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/details/" + data.id);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/update/" + data.id, data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/create", data);
    }

    bulk_edit(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/bulk_edit", data);
    }

    bulk_delete(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/bulk_delete", data);
    }

    between(data: any): Promise<object> {
        let start = data.start && data.start != "" ? "/" + data.start : "";
        let end = data.end && data.end != "" ? "/" + data.end : "";
        return this.$http.get(this.v2Root + "/between" + start + end, {
            params: data,
        });
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.v2Root + "/" + data.id);
    }
}

angular.module("vcServices").service("AppointmentService", AppointmentService);
